
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 791.803 791.803","fill":"#C17707"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M395.904 475.016l-236.203-72.7v121.42c0 56.133 105.787 101.644 236.274 101.644 130.48 0 236.285-45.511 236.285-101.644 0-.442-.145-.886-.154-1.318V402.316l-236.202 72.7z"}}),_c('path',{attrs:{"d":"M0 318.734l84.383 30.185 7.191-15.401 31-2.635 4.42 4.599-26.601 6.308-3.877 11.475c-.007 0-60.087 125.604-51.263 187.05 0 0 37.502 22.37 74.988 0l9.962-168v-13.984l55.8-12.588-3.941 9.705-41.604 13.529 19.242 6.874 236.203 72.7 236.201-72.7 159.699-57.116-395.9-152.313L0 318.734z"}})])
          )
        }
      }
    